import React from 'react';

import Dividends from '../../../components/drprofile/DividendsFinalAnnouncements';
import { getDividensFinal } from '../../utils/apiCalls';

const FinalAnnouncementTable = props => <Dividends endpoint={getDividensFinal} {...props} />

export default FinalAnnouncementTable;
